






























import Vue, { PropType } from 'vue';

import { ServiceAssignmentAttachment } from '@/types';

export default Vue.extend({
  props: {
    attachments: {
      type: Array as PropType<ServiceAssignmentAttachment[]>,
      default: () => [],
    },
  },

  methods: {
    isImage(attachment: ServiceAssignmentAttachment): boolean {
      return (
        (attachment.mime_type || '').startsWith('image/') ||
        /\.(png|jpe?g|gif|webp)$/i.test(attachment.name)
      );
    },

    isPdf(attachment: ServiceAssignmentAttachment): boolean {
      return (
        attachment.mime_type === 'application/pdf' ||
        /\.pdf$/i.test(attachment.name)
      );
    },
  },
});
